
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useVerificationData = () => {
  return useQuery({
    queryKey: ['cook-verification'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error('Not authenticated');

      const { data, error } = await supabase
        .from('cook_verifications')
        .select('*')
        .eq('cook_id', user.id)
        .maybeSingle();

      if (error) throw error;
      
      if (!data) {
        const { data: newVerification, error: insertError } = await supabase
          .from('cook_verifications')
          .insert({
            cook_id: user.id,
            status: 'in_progress'
          })
          .select()
          .single();
          
        if (insertError) throw insertError;
        return newVerification;
      }

      if (isVerificationComplete(data)) {
        const { error: updateError } = await supabase
          .from('cook_verifications')
          .update({ status: 'pending' })
          .eq('id', data.id);

        if (updateError) throw updateError;
        return { ...data, status: 'pending' };
      }

      return data;
    }
  });
};

const isVerificationComplete = (verification: any) => {
  return (
    verification.status === 'in_progress' && 
    verification.government_id_url && 
    verification.kitchen_photos?.length > 0 &&
    verification.food_storage_photos?.length > 0 &&
    verification.handwashing_photos?.length > 0 &&
    verification.food_separation_photos?.length > 0 &&
    verification.quiz_completed_at
  );
};
